'use client'
import { tagAnatomy } from '@chakra-ui/anatomy'
import {
  createMultiStyleConfigHelpers,
  Tag as ChakraTag,
  theme,
} from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { TagProps } from './Tag.types'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(tagAnatomy.keys)

const baseStyle = definePartsStyle({
  container: {
    gap: '0.25rem',
    justifyContent: 'center',
    borderRadius: '500px',
    fontSize: '0.875rem',
    alignItems: 'center',
    fontWeight: '600',
  },
})

const ghostVariant = definePartsStyle({
  container: {
    backgroundColor: 'white',
    color: 'gray.800',
    fontWeight: '600',
  },
})

const sizes = {
  ...theme.components.Tag.sizes,
  xs: definePartsStyle({
    container: {
      ...theme.components.Tag.sizes?.sm.container,
      padding: '0.125rem 0.5rem',
      fontSize: '0.75rem',
    },
  }),
  sm: definePartsStyle({
    container: {
      ...theme.components.Tag.sizes?.sm.container,
      padding: '0.125rem 0.5rem',
      fontSize: '0.75rem',
    },
  }),
  lg: definePartsStyle({
    container: {
      ...theme.components.Tag.sizes?.lg.container,
      padding: '0.25rem 1rem',
      fontSize: '1rem',
    },
  }),
}

export const TagStyle = defineMultiStyleConfig({
  defaultProps: {
    size: 'sm',
    variant: 'subtle',
  },
  variants: {
    ...theme.components.Tag.variants,
    ghost: ghostVariant,
  },
  baseStyle,
  sizes,
})

export default forwardRef(function Tag(
  props: TagProps,
  ref: LegacyRef<HTMLSpanElement>
) {
  return <ChakraTag {...props} ref={ref} translate="no" />
})
